import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppRoutingModule } from './app.routing';
import { SharedModule } from './shared/shared.module';
import {HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppComponent } from './app.component';

import { MAT_DATE_LOCALE } from '@angular/material/core';
import { AuthorizationInterceptor } from './core/interceptor/authorization.interceptor';
import { CookieModule } from 'ngx-cookie';
import { AffiliateMarketingComponent } from './features/affiliate-marketing/affiliate-marketing.component';
import { VerificationMarketerComponent } from './features/verification-marketer/verification-marketer.component';
import { AllUsersComponent } from './features/all-users/all-users.component';
import * as jalaliMoment from 'jalali-moment';
import * as jalaliDate from 'jalali-date';
import { NgxPersianModule } from 'ngx-persian';
import { BlockUIModule } from 'ng-block-ui';
import { ValidTimeSettingComponent } from './features/valid-time-setting/valid-time-setting.component';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    RouterModule,
    HttpClientModule,
    RouterModule,
    AppRoutingModule,
    NgxPersianModule,
    SharedModule,
    CookieModule.forRoot(),
    BlockUIModule.forRoot(),
  ],
  declarations: [
    AppComponent,
    AffiliateMarketingComponent,
    VerificationMarketerComponent,
    AllUsersComponent,
    ValidTimeSettingComponent,

  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'fa-IR' },
    {
      provide: HTTP_INTERCEPTORS,
   useClass: AuthorizationInterceptor,
   multi: true
    },
    { provide: 'jalaliMoment', useValue: jalaliMoment },
    { provide: 'jalaliDate', useValue: jalaliDate },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
